import DocumentActionTypes from "../../actions/document/types";

export default (commentFilters = null, action) => {
  switch (action.type) {
    case DocumentActionTypes.SET_COMMENT_FILTERS:
      return action.payload;
    case DocumentActionTypes.RESET_COMMENT_FILTERS:
      return null;
    default:
      return commentFilters;
  }
};
